export default __webpack_public_path__ + "static/media/world-map-background.421955d8.svg";